document.addEventListener("DOMContentLoaded", () => {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
  
      observer.unobserve(productRecommendationsSection);
  
      const url = productRecommendationsSection.dataset.url;
  
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
  
          const recommendations = html.querySelector(".Related_Products");
          const target =
            productRecommendationsSection.querySelector(".Related_Products");
  
          if (recommendations && recommendations.innerHTML.trim().length) {
            target.innerHTML = recommendations.innerHTML;
            publish(PUB_SUB_EVENTS.contentAdded, { content: target });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };
  
    const productRecommendationsSection = document.querySelector(
      ".Related_Products_Section"
    );
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 200px 0px",
    });
  
    observer.observe(productRecommendationsSection);
  });
  